import { apiGet } from "../lib/api-client";

// Types are defined locally (not in @atlas/shared) — Wrapped (PLT-4) is
// web-only for now; mobile parity is a separate workstream (PLT-5).

export interface WrappedBiggestDay {
  date: string;
  distanceKm: number;
  peaks: number;
}

export interface WrappedRarestAchievement {
  id: string;
  slug: string;
  name: string;
  tier: string;
  points: number;
  unlockedAt: string;
  holderCount: number;
}

export interface Wrapped {
  year: number;
  totalDistanceKm: number;
  activeDays: number;
  activityCount: number;
  summits: number;
  newLandmarks: number;
  trailSectionsCompleted: number;
  newRegions: number;
  biggestDay: WrappedBiggestDay | null;
  rarestAchievement: WrappedRarestAchievement | null;
  /** 12 activity counts, index 0 = January .. index 11 = December. */
  monthly: number[];
}

export interface WrappedResponse {
  wrapped: Wrapped;
}

export function fetchWrapped(year: number): Promise<WrappedResponse> {
  return apiGet(`/wrapped/${year}`);
}

/** Pre-signed link to the shareable Wrapped summary card (PLT-4). */
export function fetchWrappedShareUrl(year: number): Promise<{ url: string }> {
  return apiGet(`/wrapped/${year}/share-url`);
}

/**
 * The share-url endpoint returns the HTML OG page URL (matches the PLT-3
 * achievement/collection share-url shape) — derive the signed PNG URL for an
 * <img> preview by inserting ".png" before the query string, same as the
 * PNG variant the /share routes serve alongside the OG page.
 */
export function toShareCardImageUrl(url: string): string {
  const [path, query] = url.split("?");
  return query ? `${path}.png?${query}` : `${path}.png`;
}
